<div class="shape-wrapper" [style.width]="scale * 50 + 'vw'">
  <svg [attr.viewBox]="viewBox">
    @if (!accentColor) {
      <path #path></path>
    }
    @if (accentColor) {
      <path [style]="'fill: ' + correctedAccentColor" #path></path>
    }
  </svg>
</div>
